import { createPromiseAction, createRecordAction } from '../../utils';

export const deviceAuthNeededAction = {
  ...createRecordAction('device-auth-needed'),
};

export const fetchDeviceAuthNeededAction = createPromiseAction(
  'dvm/FETCH_DEVICE_AUTH_NEEDED'
);
